import { render } from "./Jp.vue?vue&type=template&id=b167e4dc"
import script from "./Jp.vue?vue&type=script&lang=js"
export * from "./Jp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tony.waddington/Desktop/Vue/gi-video-partners-2/v2-remove_noCodeAPI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__